import { spawn, all, call } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import opSearch from 'pages/Placement/Detail/DetailTabs/OpSearch/store/saga';
import rateInfoSaga from 'pages/Placement/Detail/DetailTabs/RateInfo/store/saga';
import demandTab from 'pages/Placement/DemandDetailsMaster/store/sagas';
import places from 'components/SearchPlaces/store/sagas';
import activityTab from 'pages/Placement/Detail/DetailTabs/ActivityTab/store/sagas';
import tripTab from 'pages/Placement/TripDetailsMaster/store/sagas';
import supplyTab from 'pages/Placement/Detail/DetailTabs/SupplyTab/store/sagas';
import UpdateVehicle from 'components/UpdateVehicle/store/saga';
import lms from 'pages/lms/store/lms.sagas';
import consigner from 'components/Consigner/store/sagas';
import transactions from 'pages/transactions/store/transactions.sagas';
import ticketingSaga from 'pages/ticketing/store/sagas';
import cmsSaga from 'pages/cms/store/cms.sagas';
import issuesSaga from 'pages/IssueCreation/store/issueCreation.sagas';
import PermissionsSaga from 'pages/permissions/store/permissions.sagas';

export default function* rootSaga() {
  const sagas = [
    opSearch,
    rateInfoSaga,
    demandTab,
    places,
    activityTab,
    tripTab,
    supplyTab,
    UpdateVehicle,
    lms,
    consigner,
    transactions,
    ticketingSaga,
    cmsSaga,
    issuesSaga,
    PermissionsSaga,
  ];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            Sentry.captureException(e);
            console.log(e);
          }
        }
      }),
    ),
  );
}
